<script setup lang="ts">
import { TEMPLATES } from "~/utilities/articles"
import { keys } from "~/utilities/injection"

defineProps<{
  parentLocationId: number | undefined
  subjectPage: boolean
}>()

const data = useProductContentStore()

const fields = computed(() => ({
  href: data.activeSubject?.frontendHref || data.activeSubject?.href,
  shortTitle: data.activeSubject?.shortTitle,
  priority: data.activeSubject?.priority,
}))

const isDark = data.activeArticle?.template === TEMPLATES.VIDEO ? true : inject(keys.isDark)
</script>

<template>
  <p
    v-if="fields.href && fields.shortTitle"
    class="mb-2 line-clamp-2 font-national2 text-xl font-extrabold uppercase xl:text-2xl"
  >
    <NuxtLink
      :to="fields.href"
      class="border-b-2 border-[--theme-dark] text-[--theme-dark]"
      :class="{
        '!border-lighter !text-lighter': isDark,
      }"
    >
      {{ fields.priority }}.
      {{ fields.shortTitle }}
    </NuxtLink>
  </p>
</template>
